import React from 'react'
import { Marker } from '@react-google-maps/api'


const MarkerComponent = (props) => {

    const marker = props.marker;

    const handlePinImgPath = (ratio, isLargePassageArea, isWA, isOpen) => {

        if (isLargePassageArea) {
            if (ratio === 0)
                return "/google-pins/wa3_marker_aireGP_free.png";
            else if (ratio <= 100)
                return "/google-pins/wa3_marker_aireGP_full.png";
            else
                return `/google-pins/wa3_marker_aireGP_closed.png`;
        }
        else if (!isWA){
            if (ratio >= 0 && ratio < 100  && isOpen === 0)
                return "/google-pins/nonWa_marker_aire_free.png";
            else if (ratio === 100 && isOpen === 0)
                return "/google-pins/nonWa_marker_aire_full.png";
            if (isOpen === 1) 
                return "/google-pins/nonWa_marker_aire_closed.png";   
        }
        else {
            if (ratio >= 0 && ratio < 100 && isOpen === 0)
                return "/google-pins/wa3_marker_aire_free.png";
            else if (ratio === 100 && isOpen === 0)
                return "/google-pins/wa3_marker_aire_full.png";
            if (isOpen === 1) 
                return "/google-pins/wa3_marker_aire_closed.png";   
        }
    }
    return (
        <Marker
            position={{ lat: marker.latitude, lng: marker.longitude }}
            
            icon={{
                url: handlePinImgPath((marker.busySlots / marker.totalSlots) * 100, marker.isLargePassageArea, marker.isWa, marker.isOpen),
                scaledSize: new window.google.maps.Size(40, 59),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 30)
            }}
            animation={2}
            onClick={props.onClick}
        />
    )
}

export default MarkerComponent
